import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Map, Bone, Route, Users, Beer, GraduationCap, Menu, PawPrint } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { KILTRO_ASSETS } from "../lib/assets";
import LanguageSwitcher from "./LanguageSwitcher";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const links = [
    { to: "/descubrir", label: t("nav.discover"), icon: Map, testid: "nav-descubrir" },
    { to: "/rutas", label: t("nav.routes"), icon: Route, testid: "nav-rutas" },
    { to: "/cupones", label: t("nav.coupons"), icon: Bone, testid: "nav-huesos" },
    { to: "/cervezas", label: t("nav.beers"), icon: GraduationCap, testid: "nav-cervezas" },
    { to: "/comunidad", label: t("nav.community"), icon: Users, testid: "nav-comunidad" },
    { to: "/nosotros", label: t("nav.about"), icon: PawPrint, testid: "nav-nosotros" },
    { to: "/mis-cupones", label: t("nav.myCoupons"), icon: Bone, testid: "nav-mis-huesos" },
    { to: "/locales", label: t("nav.addVenue"), icon: Beer, testid: "nav-sumar-local", highlight: true },
  ];
  return (
    <header className="sticky top-0 z-40 bg-[#0A0A0A]/95 backdrop-blur border-b-2 border-[#1A1A1A]" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-4 group" data-testid="nav-home-logo">
          <img
            src={KILTRO_ASSETS.logo}
            alt="Kiltro"
            className="w-12 h-12 object-contain shrink-0 group-hover:rotate-[-6deg] transition-transform duration-300"
          />
          <div className="leading-none">
            <div className="font-display text-2xl tracking-tight">
              <span className="text-white">Kiltro</span> <span className="text-[#FEBA01]">Scout</span>
            </div>
            <div className="font-body font-bold text-[10px] text-[#FEBA01] uppercase tracking-[0.25em] mt-1">Ruta Cervecera</div>
          </div>
        </Link>

        <nav className="hidden xl:flex items-center gap-0.5">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                l.highlight
                  ? `ml-2 px-3 py-2 font-body font-bold uppercase tracking-[0.08em] text-[13px] leading-tight border-2 border-[#FEBA01] whitespace-nowrap transition-colors ${
                      isActive ? "bg-[#FEBA01] text-black" : "bg-black text-[#FEBA01] hover:bg-[#FEBA01] hover:text-black"
                    }`
                  : `px-2.5 py-2 font-body font-bold uppercase tracking-[0.08em] text-[13px] leading-tight transition-colors whitespace-nowrap ${
                      isActive ? "bg-[#FEBA01] text-black" : "text-white hover:text-[#FEBA01]"
                    }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <LanguageSwitcher className="ml-2" />
        </nav>

        <button
          onClick={() => setOpen((v) => !v)}
          className="xl:hidden text-[#FEBA01] p-2"
          data-testid="nav-mobile-toggle"
          aria-label="Menu"
        >
          <Menu size={24} />
        </button>
      </div>

      {open && (
        <nav className="xl:hidden border-t-2 border-[#1A1A1A] bg-[#0A0A0A]" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              data-testid={`${l.testid}-mobile`}
              className={({ isActive }) =>
                `block px-6 py-3 font-body font-bold uppercase tracking-[0.08em] text-base border-b border-[#1A1A1A] ${
                  isActive ? "bg-[#FEBA01] text-black" : "text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <div className="px-6 py-3 border-b border-[#1A1A1A]">
            <LanguageSwitcher />
          </div>
        </nav>
      )}
    </header>
  );
}
